import { Dispatch, ReactElement, SetStateAction } from 'react';

export enum TransferState {
  IDLE,
  APPROVE,
  TRANSFER,
  SUCCESS,
  ERROR,
}

export type TransferBulkProps = {
  trigger: ReactElement;
  openState?: [boolean, Dispatch<SetStateAction<boolean>>];
  onClose?: (isTransferred: boolean) => void;
};
